import jsonp from 'jsonp';

import objectToGetParams from './utils/objectToGetParams';
import shareCountFactory from './utils/shareCountFactory';

function getTumblrShareCount(shareUrl, callback) {
  var endpoint = 'https://api.tumblr.com/v2/share/stats';

  return jsonp(endpoint + objectToGetParams({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.note_count : undefined);
  });
}

export default shareCountFactory(getTumblrShareCount);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-share/es/TumblrShareCount.js
// module id = 1681
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21